export default __webpack_public_path__ + "static/media/mothlyWaff.ed23ebe0.png";